<table>
    @for (overview of overviews; track overviewTrackByFn($index, overview)) {
        <tr>
            <td style="width: 40px">
                <app-svg-icon
                    [icon]="overview.journal ? 'history' : 'log'"
                    [tooltip]="(overview.journal ? 'journal.title' : 'auditTrails.title') | translate"
                    fill="orange"
                >
                </app-svg-icon>
            </td>
            <td style="width: 130px">
                {{ overview.timestamp | momentTime: true }}
            </td>
            <td style="width: 150px">
                <app-navigator
                    [device]="overview.device"
                    [enabled]="overview.measuringPoint?.id !== measuringPoint?.id"
                    [measuringPoint]="overview.measuringPoint"
                ></app-navigator>
            </td>
            <td>
                @if (overview.journal) {
                    <span pTooltip="{{ overview.journal.category.description }}">
                        {{ overview.journal.category.codeStringResourceId | translateModel }}
                    </span>
                    <span pTooltip="{{ overview.journal.subCategory.description }}">
                        {{ overview.journal.subCategory.codeStringResourceId | translateModel }}
                    </span>
                } @else {
                    <app-domain-data-field
                        [enumKey]="overview.auditTrail.eventType"
                        domainDataType="auditTrailEventType"
                    >
                    </app-domain-data-field>
                }
            </td>
        </tr>
    }
</table>
